export default __webpack_public_path__ + "static/media/ImageSectionImageFullWidth.c28247a9.svg";